var pointInSvgPolygon = require("point-in-svg-polygon");
var svgNS = "http://www.w3.org/2000/svg";
var ZevensterAreaService = /** @class */ (function () {
    function ZevensterAreaService() {
        this.svg = require('./area.svg');
        this.visibleSquares = require('./visible-squares.json');
        // TODO: only non-bought ids
        this.randomlySelectedAreaId = Math.floor(Math.random() * this.visibleSquares.length);
        this.parseArea();
    }
    ZevensterAreaService.prototype.parseArea = function () {
        var c = document.createElement('div');
        c.innerHTML = this.svg;
        var svgEl = c.querySelector('svg');
        var boundary = svgEl.querySelector('#boundary');
        var polygon = boundary.querySelector('polygon');
        var squares = svgEl.querySelector('#squares');
        var height = 800;
        var width = 800;
        var sqHeight = 4.116;
        var sqWidth = sqHeight;
        var nSqHori = Math.ceil(height / sqHeight);
        var nSqVert = Math.ceil(width / sqWidth);
        var allRects = [];
        var bigSquaresTopLefts = [];
        for (var _i = 0, _a = this.visibleSquares; _i < _a.length; _i++) {
            var squareI = _a[_i];
            var col = squareI % nSqHori;
            var row = Math.floor(squareI / nSqVert);
            var bigSqTopLeftCol = col - (col % 3);
            var bigSqTopLeftRow = row - (row % 3);
            var bigSqTopLeftSquareI = bigSqTopLeftCol + bigSqTopLeftRow * nSqHori;
            if (bigSquaresTopLefts.indexOf(bigSqTopLeftSquareI) !== -1)
                continue;
            var rect = document.createElementNS(svgNS, 'rect');
            rect.x.baseVal.value = sqWidth * col;
            rect.y.baseVal.value = sqWidth * row;
            rect.width.baseVal.value = sqWidth;
            rect.height.baseVal.value = sqHeight;
            rect.setAttribute('square-all-ids', squareI.toString());
            rect.setAttribute('square-id', squareI.toString());
            if (!(col % 3) && !(row % 3)) {
                var hasAll = true;
                var allIds = [squareI, squareI + 1, squareI + 2, squareI + nSqHori, squareI + nSqHori + 1, squareI + nSqHori + 2, squareI + 2 * nSqHori, squareI + 2 * nSqHori + 1, squareI + 2 * nSqHori + 2];
                for (var _b = 0, allIds_1 = allIds; _b < allIds_1.length; _b++) {
                    var allId = allIds_1[_b];
                    if (this.visibleSquares.indexOf(allId) === -1) {
                        hasAll = false;
                        break;
                    }
                }
                if (hasAll) {
                    rect.width.baseVal.value = sqWidth * 3;
                    rect.height.baseVal.value = sqHeight * 3;
                    rect.setAttribute('square-big', '');
                    rect.setAttribute('square-all-ids', allIds.join(','));
                    bigSquaresTopLefts.push(squareI);
                }
            }
            squares.appendChild(rect);
        }
        this.parsedSvg = c.innerHTML;
    };
    return ZevensterAreaService;
}());
export { ZevensterAreaService };
//# sourceMappingURL=zevenster-area.service.js.map